<template>
	<div class="info-grid bgcolor-turquois">
		<div v-for="(item, index) in items" :key="index" class="info-grid__item" v-if="getCalculation.real_estate.type === 0 || item.condominium_only !== true">
			{{ item.title }}
			<b>{{ infoData[item.prop] }}</b>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import DataHelper from '@/helpers/dataHelper';
import InsurersFullName from '@json/InsurersFullName.json';
export default {
	data() {
		return {
			items: [
				{ title: 'Biztosítás típusa:', prop: 'category_name' },
				{ title: 'Ingatlan típusa:', prop: 'real_estate_type' },
				{ title: 'Ingatlan tulajdoni viszonya:', prop: 'ownership' },
				{ title: 'Állandóan lakott:', prop: 'is_permanently_inhabited' },
				{ title: 'Az ingatlan külterületen fekszik?', prop: 'is_public_space' },
				{ title: 'Főépület építés alatt áll?', prop: 'under_construction' },
				{ title: 'Főépület építés éve:', prop: 'build_year' },
				{ title: 'Főépületben együttlakók száma:', prop: 'inhabitants' },
				{ title: 'Díjfizetés módja:', prop: 'payment_method' },
				{ title: 'Díjfizetés gyakorisága:', prop: 'payment_frequency' },
				{ title: 'E-kommunikációt igénybe vesz?', prop: 'is_online_communication' },
				{ title: 'E-kárrendezést igénybe vesz?', prop: 'is_online_claims_settlement' },
				{ title: 'Kockázatviselés kezdete:', prop: 'start_of_risk' },
				{ title: 'Éves díj:', prop: 'annual_fee', format: 'currency' },
                { title: 'Van társasház biztosítás?', prop: 'has_condominium_insurance', 'condominium_only': true },
                { title: 'Társasház biztosítója:', prop: 'condominium_insurer', 'condominium_only': true },
			],
		};
	},
	computed: {
		...mapGetters(['getCalculation']),
		...mapGetters('contracting', ['getSelectedOffer']),
		infoData() {
			return {
				category_name: this.getCalculation.category_name,
				real_estate_type: DataHelper.getData('REAL_ESTATE_TYPE', this.getCalculation.real_estate.type),
				ownership: DataHelper.getData('OWNERSHIP', this.getCalculation.real_estate.ownership),
				is_permanently_inhabited: this.getCalculation.real_estate.is_permanently_inhabited ? 'Igen' : 'Nem',
				is_public_space: this.getCalculation.real_estate.is_public_space ? 'Igen' : 'Nem',
				under_construction: this.getCalculation.real_estate.under_construction ? 'Igen' : 'Nem',
				build_year: this.getCalculation.real_estate.year,
				inhabitants: this.getCalculation.real_estate.inhabitants,
				payment_method: DataHelper.getData('PAYMENT_METHODS', this.getCalculation.payment_method),
				payment_frequency: DataHelper.getData('PAYMENT_FREQUENCY', this.getCalculation.payment_frequency),
				is_online_communication: this.getCalculation.is_online_communication ? 'Igen' : 'Nem',
				is_online_claims_settlement: this.getCalculation.is_online_claims_settlement ? 'Igen' : 'Nem',
				start_of_risk: moment(this.getCalculation.start_of_risk).format('yyyy.MM.DD.'),
				annual_fee: this.$options.filters.toCurrency(this.getSelectedOffer.annual_fee),
                has_condominium_insurance: this.getCalculation?.has_condominium_insurance ? 'Igen' : 'Nem',
                condominium_insurer: this.getCalculation?.condominium_insurer ? InsurersFullName[this.getCalculation?.condominium_insurer] : '-',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.bgcolor-turquois {
	background-color: rgba(237, 251, 255, 0.5);
}

.info-grid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	padding: 30px 50px 15px 50px;

	@media only screen and (max-width: 1100px) {
		padding: 15px;
	}

	&__item {
		width: 25%;
		margin-bottom: 15px;
		color: #6a7178;
		font-family: 'Arial', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		padding: 0 10px;
		box-sizing: border-box;

		@media only screen and (max-width: 1100px) {
			width: 50%;
		}

		@media only screen and (max-width: 580px) {
			width: 100%;
		}

		&:nth-child(9),
		&:nth-child(10),
		&:nth-child(11),
		&:nth-child(12) {
			margin-top: 15px;

			@media only screen and (max-width: 1100px) {
				margin-top: 0;
			}
		}

		&:nth-child(13),
		&:nth-child(14) {
			margin-bottom: 0;

			@media only screen and (max-width: 1100px) {
				margin-bottom: 15px;
			}
		}
	}
}
</style>
